import { useLocation, useHistory } from 'react-router-dom';
import { useState, useEffect } from 'react';

// Custom hook to handle object state in the URL
export function useUrlState(initialState) {
  const location = useLocation();
  const history = useHistory();

  // Helper to parse state from URL
  const parseUrlState = () => {
    const searchParams = new URLSearchParams(location.search);
    const state = {};
    Object.keys(initialState).forEach((key) => {
      const value = searchParams.get(key);
      if (value !== null) {
        state[key] = value;
      }
    });
    return { ...initialState, ...state };
  };

  const [state, setState] = useState(parseUrlState);

  // Sync state when URL changes (e.g., back/forward navigation)
  useEffect(() => {
    setState(parseUrlState());
  }, [location.search]);

  // Update the URL AND local state
  const updateUrl = (newState) => {
    const updatedParams = new URLSearchParams(location.search);

    Object.entries(newState).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        updatedParams.set(key, String(value));
      } else {
        updatedParams.delete(key);
      }
    });

    // Immediately update local state
    setState((prev) => ({
      ...prev,
      ...newState,
    }));

    // Push update to history
    history.replace({
      pathname: location.pathname,
      search: updatedParams.toString(),
    });
  };

  return [state, updateUrl];
}
